import { ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { Log } from '../util/log';
import { Overlay } from '@angular/cdk/overlay';
import { MatDialog } from '@angular/material/dialog';
import { MatSort, Sort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { NewUserRequestPermissionType } from '../model/NewUserRequestPermissionType';
import { ViewRequestTypeDialogComponent } from '../view-request-type-dialog/view-request-type-dialog.component';
import { UserService } from "../service/user.service";


@Component({
  selector: 'app-request-types',
  templateUrl: './request-types.component.html',
  styleUrls: ['./request-types.component.css']
})
export class RequestTypesComponent implements OnInit {


  @ViewChild('requeststable', { static: true }) table;
  @ViewChild('requestsloader', { static: true }) loader;
  @ViewChild(MatSort) sort: MatSort;

  lastPickedFilter: any = 1;

  requestTypesList: NewUserRequestPermissionType[] = [];;
  dataSource = new MatTableDataSource<NewUserRequestPermissionType>([]);

  displayedColumns: string[] = [
    'name',
    'viewType'
  ];

  ownerUid: string = "";

  constructor(
    private cdRef: ChangeDetectorRef,
    public dialog: MatDialog,
    private overlay: Overlay,
    private userService: UserService
  ) {
    this.ownerUid = this.userService.meUser.uid;
  }

  ngOnInit(): void {
  }

  ngAfterViewInit() {
    this.loader.showLoading()

    this.getOwnerTypes();
  }

  openAddTypeDialog() {
    Log.debug("openAddTypeDialog");
    this.openDialog(null);

  }


  onKey(event: any) {

    Log.debug(event.target.value)

    let filterString = event.target.value;

    this.table.dataSource.filter = filterString.trim().toLowerCase();
  }


  onRowClicked(row: NewUserRequestPermissionType) {

    Log.debug('clicked row ' + row);

    this.openDialog(row)

  }


  openDialog(row) {

    let input;
    if (row === null || row === undefined) {
      input = { data: null }
      Log.debug("row is null");

    } else {
      input = { data: row }
      Log.debug("row has value");
    }

    const scrollStrategy = this.overlay.scrollStrategies.reposition();

    const dialogRef = this.dialog.open(ViewRequestTypeDialogComponent, {
      width: '800px',
      data: input,
      scrollStrategy,
    });

    dialogRef.afterClosed().subscribe((response) => {

      Log.debug("\n\n Close dialog response");
      Log.debug(response);


      if (response === undefined || response == false) {
        // La richiesta non è stata approvata

        Log.debug("do nothing");

        return

      } else if (response == "deleted") {
        Log.debug("To delete");

        this.loader.showLoading();
        this.getOwnerTypes();

        this.cdRef.detectChanges();

      } else if (response == "created") {

        Log.debug("Created new type, reloading list");

        // Refresh the types list from the server so the newly created item appears
        this.loader.showLoading();
        this.getOwnerTypes();

        this.cdRef.detectChanges();

      } else {

        Log.debug("do stuff");

        this.cdRef.detectChanges();
      }
    });
  }


  filterTable(data: NewUserRequestPermissionType, filter: string): boolean {

    if (data.name.toLowerCase().indexOf(filter) != -1) {
      return true;
    }

    return false;
  }


  getOwnerTypes() {

    this.userService.getNewUserRequestPermissionType(this.ownerUid).subscribe((response) => {
      Log.debug(response);

      this.requestTypesList = response;

      this.table.dataSource = new MatTableDataSource(this.requestTypesList);
      this.table.dataSource.filterPredicate = this.filterTable;
      this.table.dataSource.sort = this.sort;

      setTimeout(() => {
        this.loader.hideLoading();
      }, 300);

    }, (err) => {
      Log.debug(err);
      this.loader.showError();
    });

  }

}
